import { type TeamData } from '~/components/BettingInsights/types';
import { type SearchRepubCountry } from '~/search-domain/types';

/**
 * Get the localised team name based on repub country, with fallback to English name
 */
export const getLocalisedTeamName = (
  team: TeamData | undefined,
  repubCountry: SearchRepubCountry | undefined,
  fallback: string,
): string => {
  if (!team) return fallback;
  return (repubCountry && team.nameMap?.[repubCountry]) || team.name || fallback;
};
